// The Project Tracker and Ticket Station guides (15_SampleTracker.jsx · ModuleHelp, Max 01/11).
const en = {
  ptCardsT: 'Where the projects stand',
  ptCardsB: 'Projects and their SKUs by state: complete, dropped, active, priority, on track, concern. Click a card to list only those.',
  ptFiltersT: 'Narrow the list',
  ptFiltersB: 'Filter by status, team, owner, assignee, designer or sales rep, or search a name or SKU. Clear puts everything back.',
  ptNewT: 'Create a project',
  ptNewB: 'Team managers start a project here with its SKUs. It stays Pending until it is approved in Project Approval.',
  ptGridT: 'The projects and their SKUs',
  ptGridB: 'One block per project with a row per SKU and its stages and dates. Click a row to edit it; the column menu chooses what is shown.',
  ptReportT: 'The report',
  ptReportB: 'Opens the Project Tracker report in a new tab, and Export Excel beside it downloads exactly what the list shows.',
  tkCardsT: 'Tickets at a glance',
  tkCardsB: 'All, open, closed, cancelled and overdue tickets. Click a card to show only those.',
  tkFiltersT: 'Find a ticket',
  tkFiltersB: 'Filter by status, requester, team, department or priority, or search by text. Export Excel takes what is shown.',
  tkNewT: 'Open a ticket',
  tkNewB: 'Ask another team for something on a project: pick the ticket code, the project and the due date, and the assignee is notified.',
  tkTableT: 'The tickets',
  tkTableB: 'Each ticket with its project, owner, due date and status. Open one to follow up, reply or close it.',
};
const ko = {
  ptCardsT: '프로젝트 현황',
  ptCardsB: '상태별 프로젝트와 SKU 수: 완료, 드롭, 진행, 우선, 정상, 우려. 카드를 클릭하면 해당 항목만 표시됩니다.',
  ptFiltersT: '목록 좁히기',
  ptFiltersB: '상태, 팀, 담당자, 지정자, 디자이너, 영업 담당으로 필터하거나 이름·SKU로 검색합니다. 초기화로 모두 되돌립니다.',
  ptNewT: '프로젝트 생성',
  ptNewB: '팀 매니저가 SKU와 함께 프로젝트를 시작합니다. Project Approval에서 승인될 때까지 대기 상태입니다.',
  ptGridT: '프로젝트와 SKU',
  ptGridB: '프로젝트마다 블록이 있고 SKU별 행에 단계와 날짜가 있습니다. 행을 클릭해 수정하고, 열 메뉴로 표시할 항목을 고릅니다.',
  ptReportT: '리포트',
  ptReportB: 'Project Tracker 리포트를 새 탭에서 엽니다. 옆의 Excel 내보내기는 목록에 보이는 그대로 다운로드합니다.',
  tkCardsT: '티켓 한눈에',
  tkCardsB: '전체, 진행, 완료, 취소, 기한 초과 티켓입니다. 카드를 클릭하면 해당 티켓만 표시됩니다.',
  tkFiltersT: '티켓 찾기',
  tkFiltersB: '상태, 요청자, 팀, 부서, 우선순위로 필터하거나 텍스트로 검색합니다. Excel 내보내기는 보이는 목록을 받습니다.',
  tkNewT: '티켓 열기',
  tkNewB: '프로젝트 관련 요청을 다른 팀에 보냅니다. 티켓 코드, 프로젝트, 기한을 고르면 담당자에게 알림이 갑니다.',
  tkTableT: '티켓 목록',
  tkTableB: '티켓별 프로젝트, 담당자, 기한, 상태입니다. 열어서 후속 조치, 답변, 종료를 합니다.',
};
const vi = {
  ptCardsT: 'Tình hình các dự án',
  ptCardsB: 'Số dự án và SKU theo trạng thái: hoàn thành, hủy, đang chạy, ưu tiên, đúng tiến độ, cần chú ý. Bấm một thẻ để chỉ hiện những dòng đó.',
  ptFiltersT: 'Lọc danh sách',
  ptFiltersB: 'Lọc theo trạng thái, team, owner, người phụ trách, designer hoặc sales rep, hay tìm theo tên, SKU. Nút Xóa lọc trả lại tất cả.',
  ptNewT: 'Tạo dự án',
  ptNewB: 'Quản lý team tạo dự án kèm các SKU ở đây. Dự án ở trạng thái Chờ duyệt cho tới khi được duyệt ở Project Approval.',
  ptGridT: 'Dự án và SKU',
  ptGridB: 'Mỗi dự án là một khối, mỗi SKU một dòng với các giai đoạn và ngày. Bấm vào dòng để sửa; menu cột chọn những cột muốn xem.',
  ptReportT: 'Báo cáo',
  ptReportB: 'Mở báo cáo Project Tracker ở tab mới; nút Xuất Excel bên cạnh tải đúng những gì danh sách đang hiện.',
  tkCardsT: 'Tổng quan ticket',
  tkCardsB: 'Tất cả, đang mở, đã đóng, đã hủy và quá hạn. Bấm một thẻ để chỉ hiện các ticket đó.',
  tkFiltersT: 'Tìm ticket',
  tkFiltersB: 'Lọc theo trạng thái, người yêu cầu, team, phòng ban hoặc độ ưu tiên, hay tìm theo chữ. Xuất Excel lấy đúng danh sách đang hiện.',
  tkNewT: 'Mở ticket',
  tkNewB: 'Nhờ team khác làm một việc cho dự án: chọn mã ticket, dự án và hạn, người được giao sẽ nhận thông báo.',
  tkTableT: 'Danh sách ticket',
  tkTableB: 'Mỗi ticket kèm dự án, người phụ trách, hạn và trạng thái. Mở ticket để theo dõi, trả lời hoặc đóng.',
};
const zh = {
  ptCardsT: '项目概况',
  ptCardsB: '按状态统计的项目和 SKU：完成、取消、进行中、优先、正常、需关注。点击卡片只显示对应项目。',
  ptFiltersT: '筛选列表',
  ptFiltersB: '按状态、团队、负责人、执行人、设计师或销售筛选，或按名称、SKU 搜索。清除可恢复全部。',
  ptNewT: '新建项目',
  ptNewB: '团队经理在此创建项目及其 SKU。项目在 Project Approval 中获批前一直处于待审批状态。',
  ptGridT: '项目与 SKU',
  ptGridB: '每个项目一个区块，每个 SKU 一行，显示各阶段和日期。点击行即可编辑；列菜单可选择显示的列。',
  ptReportT: '报告',
  ptReportB: '在新标签页打开 Project Tracker 报告；旁边的导出 Excel 会下载列表当前显示的内容。',
  tkCardsT: '工单概览',
  tkCardsB: '全部、进行中、已关闭、已取消和逾期工单。点击卡片只显示对应工单。',
  tkFiltersT: '查找工单',
  tkFiltersB: '按状态、申请人、团队、部门或优先级筛选，或按文字搜索。导出 Excel 获取当前显示的列表。',
  tkNewT: '新建工单',
  tkNewB: '就项目向其他团队提出请求：选择工单代码、项目和截止日期，负责人会收到通知。',
  tkTableT: '工单列表',
  tkTableB: '每个工单的项目、负责人、截止日期和状态。打开工单可跟进、回复或关闭。',
};
const dictionary = { ns: 'tourTracker', en, ko, vi, zh };
export default dictionary;
